export default __webpack_public_path__ + "static/media/press_room_img3.aac647fc.png";